import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Lead } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import { clearSelection, selectMultiplyItems } from "@app/scene/map/store/mapMode/actions";
import {
  getFilteredLeadFinderRecords,
  getFilteredSelectedRecordsCount,
} from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import { leadIdGetter } from "@app/util/map/idGetters";

import styles from "./Actions.module.scss";

interface Props {
  clearSelection: typeof clearSelection;
  records: Array<Lead>;
  selectedCount: number;
  selectMultiplyItems: typeof selectMultiplyItems;
}

const Actions: React.FC<Props> = ({
  clearSelection,
  records,
  selectedCount,
  selectMultiplyItems,
}) => {
  const intl = useIntl();

  const allSelected = records.length > 0 && records.length === selectedCount;

  const handleSelect = useCallback(() => {
    if (allSelected) {
      clearSelection();
    } else {
      selectMultiplyItems(records.map(leadIdGetter));
    }
  }, [allSelected, clearSelection, records, selectMultiplyItems]);

  return records.length ? (
    <Button className={styles.btn} onClick={handleSelect} type="link">
      {allSelected
        ? intl.formatMessage({
            id: "map.tool.leadFinder.records.actions.clearSelected",
            defaultMessage: "Clear selected",
            description: "Clear selected button title",
          })
        : intl.formatMessage({
            id: "map.tool.leadFinder.records.actions.selectAll",
            defaultMessage: "Select all leads",
            description: "Select all leads default title",
          })}
    </Button>
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  records: getFilteredLeadFinderRecords(state),
  selectedCount: getFilteredSelectedRecordsCount(state),
});

const mapDispatchToProps = {
  clearSelection,
  selectMultiplyItems,
};

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
